import z from 'zod'

export const referralGenerationConfigSchema = z.object({
  codeCount: z.number().int().min(1),
  freeMonths: z.number().int().min(1),
  cascading: z.boolean().default(true),
})

export type ReferralGenerationConfig = z.infer<typeof referralGenerationConfigSchema>

export const promotionProvenanceSchema = z.object({
  generatedByPromotionId: z.string().uuid().optional(),
  generatedForUserId: z.string().uuid().optional(),
  generatedBySubscriptionId: z.string().uuid().optional(),
})

export type PromotionProvenance = z.infer<typeof promotionProvenanceSchema>

export const promotionDataSchema = z.object({
  referralGeneration: referralGenerationConfigSchema.optional(),
  provenance: promotionProvenanceSchema.optional(),
})

export type PromotionData = z.infer<typeof promotionDataSchema>

export type UserReferralPromotion = {
  id: string
  promotionCode: string
  freeMonths: number
  isActivated: boolean
}
